/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_UnansweredInputs */

const en_us2_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not answered`)
};

const pt_br2_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não respondida`)
};

const es_419_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin responder`)
};

const pt_pt2_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem resposta`)
};

const fr_fr2_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans réponse`)
};

const de_de2_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht beantwortet`)
};

const it_it2_coach_extra_ask_unanswered = /** @type {(inputs: Coach_Extra_Ask_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza risposta`)
};

/**
* | output |
* | --- |
* | "Not answered" |
*
* @param {Coach_Extra_Ask_UnansweredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_unanswered = /** @type {((inputs?: Coach_Extra_Ask_UnansweredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_UnansweredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_unanswered(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_unanswered(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_unanswered(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_unanswered(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_unanswered(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_unanswered(inputs)
	return en_us2_coach_extra_ask_unanswered(inputs)
});
export { coach_extra_ask_unanswered as "coach-extra.ask_unanswered" }